import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {mapQuizSessionTypeToDb} from './mapQuizSessionTypeToDb';
import {QuizSessionDb} from './quizSessionDbSchema';
import {QuizSession} from './quizSessionSchema';
import {resetSessionQuestion} from './sessionQuestion/resetSessionQuestion';

/**
 * Reset a quiz session by resetting all questions.
 * @param session
 * @returns
 */
export function resetQuizSession(session: QuizSession, timestamp: FirestoreTimestamp): QuizSessionDb {
  return {
    ...mapQuizSessionTypeToDb(session, timestamp),
    /** Populate with existing questions and reset the answers */
    questions: session.questions.map(resetSessionQuestion),
  };
}
